// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Switcher from './Switcher'

type Props = {
  inputName: string,
  options: Array<[string, string]>,
  value: any
}

type State = {
  value: any
}

export default class StandaloneSwitcher extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { value: props.value }
  }

  render() {
    const { inputName, options } = this.props

    return (
      <div>
        <input type="hidden" value={this.state.value} name={inputName} />
        <Switcher
          options={_.map(options, ([name, id]) => ({ id, name }))}
          value={this.state.value}
          onChange={(value) => this.setState({ value })}
        />
      </div>
    )
  }
}
